import React from 'react';
import { useEditorActions } from '../../store/editorStore.jsx';

export function GroupCanvas({ block, children }) {
  const { background = '', padding = 16, borderRadius = 0 } = block.attrs;
  return (
    <div
      className="editor-group-block"
      style={{
        background: background || undefined,
        padding: `${padding}px`,
        borderRadius: `${borderRadius}px`,
        border: '1px dashed #ccc',
        minHeight: 60,
      }}
    >
      {children}
    </div>
  );
}

export function GroupInspector({ block }) {
  const { updateAttrs } = useEditorActions();
  const { background = '', padding = 16, borderRadius = 0 } = block.attrs;

  return (
    <div className="p-3">
      <div className="mb-3">
        <label className="form-label fw-semibold small">Background Color</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={background}
          onChange={(e) => updateAttrs(block.id, { background: e.target.value })}
          placeholder="e.g. #f0f4f8 or transparent"
        />
      </div>
      <div className="mb-3">
        <label className="form-label fw-semibold small">Padding (px)</label>
        <input
          type="range"
          className="form-range"
          min={0}
          max={64}
          step={4}
          value={padding}
          onChange={(e) => updateAttrs(block.id, { padding: Number(e.target.value) })}
        />
        <small className="text-muted">{padding}px</small>
      </div>
      <div className="mb-3">
        <label className="form-label fw-semibold small">Border Radius (px)</label>
        <input
          type="range"
          className="form-range"
          min={0}
          max={24}
          step={2}
          value={borderRadius}
          onChange={(e) => updateAttrs(block.id, { borderRadius: Number(e.target.value) })}
        />
        <small className="text-muted">{borderRadius}px</small>
      </div>
    </div>
  );
}
